import React, { useMemo, useState } from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import Label from "components/general/Label"
import NotAvailable from 'components/common/NotAvailable'
import {
    TableColumnsComb as ColumnsRes
} from 'components/sports/ath/combined_points/Columns'
import { useViewport } from 'components/general/useViewPort'
import { getIsEventDecathlon } from 'components/sports/ath/helper/AthHelpers'
import { useEventUnit } from "components/common/EventUnit";

const getConfiguration = (rsc, eu) => {
    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
    };
    const isEventDecathlon = getIsEventDecathlon(rsc);


    configuration.caption = <CaptionTable
        leftCol={<Label data="HeaderCombinedPts" />}
    //centerCol={<span className="text-dark">{resultStatus}</span>}
    // rightCol={<Status typeToPrint='result' scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={resultStatus} />}
    />

    //configuration.sortBy = isStartList
    //    ? [{ id: 'Bib', desc: false }]
    //    : [{ id: 'Rank', desc: false }]

    configuration.columns = ColumnsRes(isEventDecathlon, rsc, eu);
    return configuration;
};


const AthCombinedPoints = ({ data }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.cumulativeResults?.status?.code;
    const eu = useEventUnit()

    const configEvent = useMemo(() => getConfiguration(mirs_rsc, eu), [resultStatus]);
    //const configEvent =  getConfiguration(mirs_rsc);


    // Create a function that will render our row sub components
    const items = data?.cumulativeResults?.results

    //Si el contenido de una columna esta vacia la ocultamos(ver casos)
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []

    //numero de splits visibles 
    const extendedColsVisibles = (breakPoint === "sm" || breakPoint === "xs") ? 1 : 4;
    //const colIndex = (breakPoint === "sm" || breakPoint === "xs") ? 1 : 2;


    return (
        <>
            {items ? (
                < MirsTable
                    className='table-result'
                    //Dato to show by row
                    data={items}
                    //Columnas a visualizar 
                    columns={configEvent.columns}
                    //Key by row necesary in order to no paint innecesary
                    keyRow='participant-code'
                    //Splits to show
                    colsExtendedVisible={extendedColsVisibles}
                    hasRelatedTimeline={false}
                    //current split (initial)
                    // colIndex={colIndex} //Columna Posicionada con splits
                    //Component caption
                    //caption={configEvent.caption}
                    //Columns to hidde 
                    hiddenColumns={hiddenColumns}
                    //When show tble is sorted by 
                    initialSortBy={configEvent.sortBy}
                    //Show buttons move to splits 
                    showNavExtendedData={true}
                    id={`mirs-table-summary-${mirs_rsc}`}
                />
            ) : <NotAvailable />
            }
        </>
    );
};

export default AthCombinedPoints;
